import { Component, OnInit, Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute) {

  }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    // not logged in so redirect to login page with the return url

     if (localStorage.getItem('idUser')) {
       return true;
     }

     this.router.navigate(['/login']);
     return false;
 
  }

}
